// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderSection_header__ZRlCk","titleBacklight":"HeaderSection_titleBacklight__3O09U","count":"HeaderSection_count__pGBK7","link":"HeaderSection_link__DfgjC"};